import { Icon } from '@acast/decibel';
import { MusicSolidGlyph } from '@acast/decibel-glyphs';
import T from 'prop-types';
import React from 'react';
import HiddenFileSelectButton from './hidden-file-select-button';

const MediaMissingPane = ({ type, onFileSelected }) => (
  <div className={`missing-media-pane missing-media-pane--${type}`}>
    <div className="missing-media-pane__icon">
      <Icon glyph={MusicSolidGlyph} size="1em" />
    </div>
    <div className="missing-media-pane__label">
      Drop file here to upload
      <br />
      or
      <br />
      <div className="missing-media-pane__misc">
        <HiddenFileSelectButton onFileSelected={onFileSelected} label="Click here to select file" />
      </div>
    </div>
  </div>
);

MediaMissingPane.propTypes = {
  type: T.oneOf(['success', 'info', 'warning', 'error']),
  onFileSelected: T.func,
};

export default MediaMissingPane;
